import { Injectable } from "@angular/core";
import { AuthenticationProvider } from "@microsoft/microsoft-graph-client";
import { firstValueFrom, Observable, shareReplay } from "rxjs";
import { AuthService } from "@services/auth/auth.service";

@Injectable()
export class MsGraphProviderService implements AuthenticationProvider {

  activeAccessToken: string | undefined;
  newAccessToken: Observable<string>

  constructor(
    private authService: AuthService,
  ) {
    this.newAccessToken = this.getNewAccessToken().pipe(
      shareReplay() // TODO: Missing test
    )
  }

  public async getAccessToken(): Promise<string> {
    if (this.activeAccessToken == undefined) {
      this.activeAccessToken = await firstValueFrom(this.newAccessToken)
    } else if (this.isTokenExpired(this.activeAccessToken)){
      this.newAccessToken = this.getNewAccessToken().pipe(
        shareReplay() // TODO: Missing test
      )
      this.activeAccessToken = await firstValueFrom(this.newAccessToken)
    }
    return this.activeAccessToken!;
  }

  private getNewAccessToken() {
    return this.authService.getMSGraphAccessToken();
  }

  public isTokenExpired(token: string) : boolean {
    let payload = token.split('.')[1]
    let decodedPayload = atob(payload)
    let jsonPayload = JSON.parse(decodedPayload)
    return jsonPayload.exp < new Date().getTime() / 1000;
  }

}
